import type { DisruptionFailure } from "@b2bportal/air-disruption-api";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import type { ButtonTypeEnum } from "@b2bportal/core-ui";
import type { RichError } from "@b2bportal/core-utilities";

export const RebookErrorModalActionType = {
  DISMISS: "dismiss",
  RETRY: "retry",
  CUSTOM: "custom",
} as const;
export type RebookErrorModalActionType =
  (typeof RebookErrorModalActionType)[keyof typeof RebookErrorModalActionType];

export type RebookErrorModalAction =
  | {
      type: (typeof RebookErrorModalActionType)["DISMISS"];
      dismiss?: () => void;
      label?: React.ReactNode;
      className?: string;
      style?: ButtonTypeEnum;
    }
  | {
      type: (typeof RebookErrorModalActionType)["RETRY"];
      retry: () => void;
      shouldDismiss?: boolean;
      label?: React.ReactNode;
      className?: string;
      style?: ButtonTypeEnum;
    }
  | {
      type: (typeof RebookErrorModalActionType)["CUSTOM"];
      label: React.ReactNode;
      shouldDismiss?: boolean;
      action: () => void;
      className?: string;
      style?: ButtonTypeEnum;
    };

export interface RebookErrorModalProps extends PlatformComponentProps {
  open: boolean;
  error: RichError<DisruptionFailure>;
  onDismiss?: () => void;
  actions?: RebookErrorModalAction[];
}
